///
/// EarthBrowser
///
/// Created by Matt Giger on 10/28/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Haptic ticks for camera moments that have a physical analogue: the
/// compass snapping to north, the 2D/3D toggle, a pinch hitting the
/// altitude floor. Native shells only; on the web this is a no-op (the
/// plugin's web fallback would buzz Android Chrome through
/// navigator.vibrate, which nobody wants from a web page).
///

import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { isNativeApp } from './platform'

export type HapticStrength = 'light' | 'medium'

const cStyles: Record<HapticStrength, ImpactStyle> = {
	light: ImpactStyle.Light,
	medium: ImpactStyle.Medium,
}

/** Fire-and-forget impact tick; never throws, never awaits */
export function hapticTick(strength: HapticStrength = 'light'): void {
	if (!isNativeApp()) return
	Haptics.impact({ style: cStyles[strength] }).catch(() => {
		// Plugin missing from a partially synced build; cosmetic only
	})
}
